export const dropdownHeight = (itemsLength: number) => {
	let x = itemsLength;
	return !x ? 50 : x < 5 ? 40 * x : 200;
};
